import { useTranslation } from 'react-i18next';
import Container from '../../components/Container';
import ViewHeader from '../../components/ViewHeader';
import useDashboard from '../../hooks/useDashboard';
import DashboardOffers from '../../components/DashboardOffers';
import DashboardSampleRequests from '../../components/DashboardSampleRequests/DashboardSampleRequests';
import DashboardMessages from '../../components/DashboardMessages';
import DashboardSection from '../../components/DashboardSection';
import './Home.scss';

function Home() {
  const { t } = useTranslation();

  const {
    messages,
    sampleRequests,
    offers,
    markAsRead,
    archive,
  } = useDashboard();

  return (
    <Container>
      <ViewHeader title={t('summary.title-summary')} />
      <div className="dashboard">
        <DashboardSection title={t('summary.label-unread-messages')} {...messages} className="dashboard-left">
          <DashboardMessages {...messages} onMarkAsRead={markAsRead} onArchive={archive} />
        </DashboardSection>
        <div className="dashboard-right">
          <DashboardSection title={t('summary.label-pending-sample-requests')} {...sampleRequests}>
            <DashboardSampleRequests {...sampleRequests} />
          </DashboardSection>
          <DashboardSection title={t('summary.label-incomplete-offers')} {...offers}>
            <DashboardOffers {...offers} />
          </DashboardSection>
        </div>
      </div>
    </Container>
  );
}

export default Home;
